import { render, staticRenderFns } from "./ComboMidia.vue?vue&type=template&id=489a3524"
import script from "./ComboMidia.vue?vue&type=script&lang=ts"
export * from "./ComboMidia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports